import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 18l-14 -4","key":"svg-0"}],["path",{"d":"M19 14l-14 -4l14 -4","key":"svg-1"}]]

/**
 * IconMathEqualLower
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWF0aC1lcXVhbC1sb3dlciIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTkgMThsLTE0IC00IiAvPgogIDxwYXRoIGQ9Ik0xOSAxNGwtMTQgLTRsMTQgLTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/math-equal-lower
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMathEqualLower = createReactComponent('outline', 'math-equal-lower', 'MathEqualLower', __iconNode);

export default IconMathEqualLower;